import { useEffect, useRef } from "react";

export const useSectionActive = (sectionActive, options = {}) => {
    const {
        offset = 0,
        delay = 0,
    } = options;

    const ref = useRef(null);
    const hasTriggered = useRef(false);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;

        if (!sectionActive) {
            el.classList.remove("is-show");
            hasTriggered.current = false;
            return;
        }

        const handleScroll = () => {
            const rect = el.getBoundingClientRect();
            const triggerPoint = window.innerHeight * 0.8;

            if (!hasTriggered.current && rect.top < triggerPoint - offset) {
                el.classList.add("is-show");
                hasTriggered.current = true;
            }
        };

        window.addEventListener("scroll", handleScroll);
        handleScroll();

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [sectionActive, offset]);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        el.style.transitionDelay = `${delay}s`;
    }, [delay]);

    return ref;
};